module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"badge":"AI 尺码推荐"}}')
  delete Component.options._Ctor
}
